import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiAddress\GetWikiAddressByCityController::__invoke
* @see app/Http/Controllers/WikiAddress/GetWikiAddressByCityController.php
* @route '/api/wiki-address/by-city/{city}'
*/
const GetWikiAddressByCityController = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiAddressByCityController.url(args, options),
    method: 'get',
})

GetWikiAddressByCityController.definition = {
    methods: ["get","head"],
    url: '/api/wiki-address/by-city/{city}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiAddress\GetWikiAddressByCityController::__invoke
* @see app/Http/Controllers/WikiAddress/GetWikiAddressByCityController.php
* @route '/api/wiki-address/by-city/{city}'
*/
GetWikiAddressByCityController.url = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { city: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { city: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            city: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        city: typeof args.city === 'object'
        ? args.city.id
        : args.city,
    }

    return GetWikiAddressByCityController.definition.url
            .replace('{city}', parsedArgs.city.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiAddress\GetWikiAddressByCityController::__invoke
* @see app/Http/Controllers/WikiAddress/GetWikiAddressByCityController.php
* @route '/api/wiki-address/by-city/{city}'
*/
GetWikiAddressByCityController.get = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiAddressByCityController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiAddress\GetWikiAddressByCityController::__invoke
* @see app/Http/Controllers/WikiAddress/GetWikiAddressByCityController.php
* @route '/api/wiki-address/by-city/{city}'
*/
GetWikiAddressByCityController.head = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetWikiAddressByCityController.url(args, options),
    method: 'head',
})

export default GetWikiAddressByCityController